import { Box, Container, Typography } from '@mui/material';

export function NotFoundPage() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
      <Container>
        <Typography variant="h1" textAlign="center">
          Page Not Found
        </Typography>
      </Container>
    </Box>
  );
}
